var React = require('react');

function HomeRedesign (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.1836 2.49756L2.43359 7.74756V20.4976C2.43359 21.3259 3.10522 21.9976 3.93359 21.9976H9.18359V13.7491L15.1836 13.7498V21.9976H21.9336V7.74756L12.1836 2.49756ZM20.4336 20.4976H16.6836V12.2498H15.1836L9.18359 12.2491H7.68359V13.7491V20.4976H3.93359V8.64343L12.1836 4.20118L20.4336 8.64343V20.4976Z","fill":"#16B639"}));
}

HomeRedesign.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = HomeRedesign;

HomeRedesign.default = HomeRedesign;
